import { CallToActionViewController } from "./CallToActionViewController";
import { TEXT_PLACE_YOUR_BETS } from "./CallToActionViewController";
import { ChunkChangeEvent } from "../../Event/ChunkChangeEvent";
import { PhaseChangeEvent } from "../../Event/PhaseChangeEvent";

export const TEXT_MATCH = 'Live';
export const TEXT_RESULTS = 'Results';

export const CYCLE_BETTING = 'betting';
export const CYCLE_MATCH = 'match';
export const CYCLE_RESULT = 'result';

export class RetailCallToActionViewController extends CallToActionViewController {
    protected matchCycleColor: string;
    protected resultCycleColor: string;


    constructor( options ) {
        options = options || { };
        super( options );
        //this.matchCycleColor = options.matchCycleColor || '#ffffff';
        //this.resultCycleColor = options.resultCycleColor || '#ffffff';
        this.matchCycleColor = options.matchCycleColor || '#ff0000';
        this.resultCycleColor = options.resultCycleColor || '#ff0000';
    }


    // ************************** Event handlers **************************

    protected refreshText() {
        if( ! this.callToActionView ) {
            return;
        }
        var phase = app.timeline.currentPhaseModel.phase;
        var chunk = app.timeline.currentChunkModel.chunk;

        var currentRound = chunk.round();
        if( ! currentRound ) {
            console.log( 'RetailCallToActionViewController: Cannot determine current round from chunk', chunk );
            // TODO Maintenance ?
            return;
        }

        var currentCycle = phase.cycle();
        if( ! currentCycle ) {
            console.log( 'RetailCallToActionViewController: Cannot determine current cycle from phase', phase );
            // TODO Maintenance ?
            return;
        }

        this.log( 'PHASE', phase.name, 'ROUND', currentRound, 'CYCLE', currentCycle );

        if( currentCycle == CYCLE_MATCH ) {
            this.callToActionView.lockView.show();
            this.callToActionView.clockView.stop();
            this.callToActionView.clockView.clear();
            this.callToActionView.textView.setText( __(TEXT_MATCH) );
            this.setColorForSubViews( this.matchCycleColor );
        }
        else if( currentCycle == CYCLE_BETTING ) {
            //this.callToActionView.lockView.show();
            //this.callToActionView.clockView.stop();
            //this.callToActionView.clockView.clear();
            this.callToActionView.textView.setText( __(TEXT_PLACE_YOUR_BETS) );
        }
        else if( currentCycle == CYCLE_RESULT ) {
            this.callToActionView.lockView.show();
            this.callToActionView.clockView.stop();
            this.callToActionView.clockView.clear();
            this.callToActionView.textView.setText( __(TEXT_RESULTS) );
            this.setColorForSubViews( this.resultCycleColor );
        }
        else {
            this.callToActionView.lockView.show();
            this.callToActionView.clockView.stop();
            this.callToActionView.clockView.clear();
            this.callToActionView.textView.setText( '' );
        }
    }

    handleChunkChangeEvent( event:ChunkChangeEvent, provider ) {
        //console.log('handleChunkChangeEvent');
        super.handleChunkChangeEvent( event, provider );
        this.refreshText();
    }

    /**
     * Sent by countdown clock
     */
    handleTimeoutEvent( event, provider ) {
        //console.log('handleTimeoutEvent');
        super.handleTimeoutEvent( event, provider );
        if( provider != app.inactivityController ) {
            this.refreshText();
        }
    }

    handlePhaseChangeEvent( event:PhaseChangeEvent, provider ) {
        //console.log('handlePhaseChangeEvent');
        this.refreshText();
    }
}